<template>
  <icon-circle fill="#606266" :stroke-width="0"></icon-circle>
</template>
<script>
export default {
  name: 'icon-circle-solid',
}
</script>